import React from 'react';
import * as MuiCore from '@material-ui/core';
import * as Formatters from '../ui/Formatters';

/*
 * Common elements for all the message formats
 */


/* Common styles */
export function styles(theme) {
  return({
    popper : {
      '& .MuiPopover-paper' : {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
        borderStyle: 'solid',
        borderRadius: 5,
        overflow: 'auto',
        maxWidth: 585,
        minWidth: 585,
        maxHeight: 683,
        marginTop: '10vh'
      },
      
    },
    root : {
      padding: 20,
      overflow: 'hidden',
      maxWidth: 650,
      width:'95vw'
    },
    detailArea : {
      maxHeight: '70vh',
      overflowY: 'auto',
      overflowX: 'hidden',
      paddingBottom: 10,
    },
    topBar : {
      display: 'flex',
      alignItems: 'flex-start',
    },
    raisedIcon : {
      height: 60,
      // width: 60,
      borderRadius: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      textAlign: 'center',
      marginLeft: 50,
      color: 'gray'
      // boxShadow: theme.shadows[8],
    },
    messageSender: {
      // marginTop: 20,
      ...theme.typography.h6,
      fontFamily: 'Sofia-bold',
      width: '100%',
      textAlign: 'center',
      fontSizr: 16
    },
    sectionHeader : {
      color: theme.rubyDarkBlue,
      fontFamily: 'Sofia-bold',
      fontSize: 14
    },
    taken: {
      width: '100%',
      textAlign: 'center',
      fontFamily: 'Sofia-bold',
      fontSize: 11,
      color: '#B3B6BD'
    },
    fieldLabel : {
      ...theme.typography.caption,
    },
    fieldData : {
      fontFamily: 'Sofia',
      fontSize: 14,
      marginTop: 3,
      wordBreak: 'break-word'
    },
    sentMessageData: {
      fontFamily: 'Sofia',
      fontSize: 14,
      backgroundColor: '#f8f8f9', 
      borderRadius: '10px 10px 0 10px', 
      float: 'right', 
      maxWidth: 260, 
      padding: 10, 
      marginTop: 2, 
      marginRight: 10
    },
    receivedMessageData: {
      fontFamily: 'Sofia',
      fontSize: 14,
      color: '#09122b', 
      border: '1px solid #d6d7db', 
      borderRadius: '10px 10px 10px 0', 
      float: 'left',
      padding: 10, 
      marginTop: 2, 
      marginLeft: 4, 
      maxWidth: 224
    },
    minutesPlayed: {
      fontFamily: 'Sofia',
      fontSize: 14,
      margin: 7
    }
  });
}

/*
 * Return section that shows read, archived, deleted, and followup or
 * empty if it's not a user level message
 */
export function MessageStatus(props) {
  if (!Boolean(props.message.deliveryId)) {
    return('');
  }
  return(
    <React.Fragment>
      <div className={props.sectionHeaderClass} style={{marginTop: 20}}>
        Message Status
      </div>
      
      <MuiCore.Grid>      
        <MuiCore.Grid item>
          <div className={props.fieldDataClass}>
            Flagged: {props.message.followup === 'Y' ? 'Yes' : 'No'}
          </div>
          {/* <div className={props.fieldDataClass}>
            {props.message.followup === 'Y' ? 'Yes' : 'No'}
          </div> */}
        </MuiCore.Grid>
        <MuiCore.Grid item>
          <div className={props.fieldDataClass}>
            Read On: {Formatters.formatDateTime(props.message.read, 'Not Read')}
          </div>
          {/* <div className={props.fieldDataClass}>
            {Formatters.formatDateTime(props.message.read, 'Not Read')}
          </div> */}
        </MuiCore.Grid>
        <MuiCore.Grid item>
          <div className={props.fieldDataClass}>
            Archived On: {Formatters.formatDateTime(props.message.archived, 'Not Archived')}
          </div>
          {/* <div className={props.fieldDataClass}>
            {Formatters.formatDateTime(props.message.archived, 'Not Archived')}
          </div> */}
        </MuiCore.Grid>
      </MuiCore.Grid>
      
    </React.Fragment>);
}


export function FormatField(field) {
  if (field.type === 'phoneNumber') {
    return(Formatters.formatPhoneNumber(field.value));
  }
  if (field.type === 'date') {
    return(Formatters.formatDate(field.value));
  }
  if (field.type === 'dateTime') {
    return(Formatters.formatDateTime(field.value));
  }
  if (field.type === 'text' && field.multiline === 'Y') {
    return(<div style={{ whiteSpace: 'pre' }}>{field.value}</div>);
  }
  if (field.type === 'checkBox') {
    return(field.value === 'true' ? 'Yes' : 'No');
  }
  return(field.value);
}

export function messageSender(message) {
  if (message.messageType === 'IC' || message.messageType === 'SMS') {
    return(Formatters.formatPhoneNumber(message.ani) + ' -> ' +
           Formatters.formatPhoneNumber(message.dnis));
  }
  if (message.messageType === 'TEXT') {
    if (Boolean(message.sendingAgent)) {
      return(message.sendingAgent);
    }
    if (Boolean(message.sendingUser)) {
      return(message.sendingUser);
    }
    return('Anonymous');
  }
  if (message.messageType === 'AGENT' || message.messageType === 'AGENT+VM') {
    if (Boolean(message.caller)) {
      return(message.caller);
    } else {
      var parsedContent = JSON.parse(message.formContent);
      var returnValue = 'Anonymous';
      if(Boolean(message.ani)){
        returnValue = Formatters.formatPhoneNumber(message.ani);
      }
      parsedContent.fields.forEach(field => {
        if(field.type === 'phoneNumber' && field.property === 'phonenumber1' && field.value !== null && field.value !== ''){
          returnValue = Formatters.formatPhoneNumber(field.value);
        }
      })
      return(returnValue);
    }
  }
  
  if (message.messageType === 'CS' || message.messageType === 'TASK') {
    return('Assist Request - ' + message.taskStatus);
  }
  
  if (message.messageType === 'VM') {
    return('Voicemail');
  }
  
  if (message.messageType === 'OC') {
    return(Formatters.formatPhoneNumber(message.outcallSourceNumber) + ' -> ' +
           Formatters.formatPhoneNumber(message.outcallNumber));
  }
  
  return('Unsupported type ' + message.messageType);
}

export function messageDisposition(message) {
  if(message?.contactDescription){
    return message?.contactDescription?.charAt(0).toUpperCase() + message?.contactDescription?.slice(1).toLowerCase();
  }
  return '';
}

export function formatDateTime(message) {
    if(message.messageType === 'CHAT'){
      let time = new Date(message.taskEndTime).toLocaleString('default', {month: 'short', day: 'numeric', weekday: 'short'}) + 
                        ", " + 
                        new Date(message.taskEndTime).toLocaleString('default', {timeStyle: 'short'}).toLowerCase();
      return `${time}`; 
    }
    if(message.messageType === 'SMS'){
      let time = new Date(message.taskEndTime).toLocaleString('default', {month: 'short', day: 'numeric', weekday: 'short'}) + 
                        ", " + 
                        new Date(message.taskEndTime).toLocaleString('default', {timeStyle: 'short'}).toLowerCase();
      return `${time}`; 
    }
    let time = new Date(message.taken).toLocaleString('default', {month: 'short', day: 'numeric', weekday: 'short'}) + 
                        ", " + 
                        new Date(message.taken).toLocaleString('default', {timeStyle: 'short'}).toLowerCase();
    return `${time}`; 
}

export function getCompany(message, user){
  return user?.userAccountRoles?.filter(account => account.accountId === message.accountId)[0]?.accountName || '';
}

export function getToDetails(message, user){
  if(message.messageType === 'OC'){
    if(message.caller && !message.caller.startsWith("+1")){
      return message.caller;
    }
    return Formatters.formatPhoneNumber(message?.outcallNumber);
  } else if(message.messageType === 'SMS' || message.messageType === 'VIP'){
    return Formatters.formatPhoneNumber(message?.dnis)
  } else if(message.messageType === 'IC'){
    return user.userAccountRoles.filter(account => account.accountId === message.accountId)[0]?.accountName
  } else if(message.messageType === 'CHAT'){
    if(message?.website.length > 40){
      return(message.website.substring(0,40) + '...')
    }
    return(message.website);
  }
  return message.messageGroupName;
}

export function messageDetail(message,user) {
  var sentTo = '';
  // if(message.userDisplayName && message.userId && user.userId !== message.userId){
  //   sentTo = ' | Sent to '+message.userDisplayName;
  // }
  if(message.messageType === 'CHAT'){
    return(message.visitorFullName);
  }
  if(message.messageType === 'SMS'){
    return(Formatters.formatPhoneNumber(message.ani));
  }
  if (message.messageType === 'TEXT' && Boolean(message.sendingAgent)) {
    return('Ruby Staff'+sentTo);
  }
  if (message.messageType === 'CS' || message.messageType === 'TASK') {
  
    if (message.taskUser) {
      
      return('Created by ' + message.taskUser +sentTo);
    } else {
      return('Created by Ruby Agent'+sentTo);
    }
  }
  if (message.messageType === 'AGENT' || message.messageType === 'IC' || message.messageType === 'VM' || message.messageType === 'AGENT+VM') {
    if (Boolean(message.ani)) {
      if(message.caller){
        return message.caller;
      } else if(message.combinedDisplayName){
        return message.combinedDisplayName;
      }else if (message.fromCity && message.fromState && message.fromCountry) {
        return(Formatters.formatPhoneNumber(message.ani) + ' ' +
               message.fromCity + ', ' + message.fromState + ' '
             + message.fromCountry+sentTo);
      } else {
        return(Formatters.formatPhoneNumber(message.ani)+sentTo);
      }
    } else {
      if(message.caller){
        return message.caller;
      } else if(message.combinedDisplayName){
        return message.combinedDisplayName
      } else {
        return("No call");
      }
    }
  }
  if (message.messageType === 'OC') {
    return(message.taskUser);
  }
  if(message.messageType === 'VIP'){
    return(message.caller || "VIP Contact")
  }
  return('');
}
